







    import Vue from 'Vue';

    export default Vue.extend({
        name:'notification-snackbar',
        data(): any {
            return {  message: '', timeout: 3000 }
        },
        computed: {
            show: {
                get(): boolean {
                    return this.$store.state.ui.showNotification;
                },
                set(newVal: boolean): void {
                    return this.$store.commit('ui/setShowNotification', newVal);
                }
            },
        },
        created (): void {
            this.$store.watch(state => state.ui.notificationMessage,
                () => {
                    const msg = this.$store.state.ui.notificationMessage;
                    this.message = msg;
                });
        },
        methods: {
        }
    });
